<!-- 表单提交页面 -->
<template>
  <div v-loading="loading">
    <template v-if="contentState === 1">
      <!-- 节点设置 -->
      <!-- 选导单独处理 -->
      <div v-if="routeInfo.name === 'selection' && !loading">
        <tutor-form :tutor-data="tutorData" @updateFn="getTutorData"></tutor-form>
      </div>

      <!-- 其他论文流程 -->
      <template v-else>
        <div v-if="nodeName" class="result-content">
          <p class="admin-remark">
            审核结果：
            <span v-if="nodeData?.paper?.extra_state?.tutor?.state" :class="'state-' + nodeData?.paper?.extra_state?.tutor?.state">
              {{ tutorState[nodeData?.paper?.extra_state?.tutor?.state] }}
            </span>
            <span v-else>未审核</span>
          </p>
          <p v-if="nodeData?.paper?.extra_state?.tutor?.remark" class="admin-remark">
            <span>反馈意见：</span>
            <span>{{ nodeData?.paper?.extra_state?.tutor?.remark }}</span>
          </p>
        </div>
        <div v-else class="result-content">
          <p v-if="routeInfo.name !== 'paper_defense'" class="admin-remark">
            <template v-if="routeInfo.name === 'review_draft'">论文评阅整体结果：</template>
            <template v-else>审核结果：</template>
            <span :class="'state-' + nodeData?.paper?.admin_state">
              {{ nodeData?.reviewSateTextData[nodeData?.paper?.admin_state] }}
            </span>
            <template v-if="routeInfo.name === 'blind_draft' && nodeData?.paper?.admin_state === 1 && nodeData?.paper.file">
              &nbsp;&nbsp;&nbsp;&nbsp;
              <el-button size="mini" type="primary" @click="downloadFile(nodeData?.paper.file[0].url, nodeData?.paper?.file[0]?.name)">下载盲审稿</el-button>
            </template>
          </p>
          <p v-if="nodeData?.paper?.admin_remark" class="admin-remark">
            <span style="white-space: nowrap">反馈意见：</span>
            <span>{{ nodeData?.paper?.admin_remark }}</span>
          </p>
        </div>
        <template v-if="routeInfo.name === 'review_draft'">
          <template v-if="nodeData?.paper?.is_update === 1 || nodeData?.paper?.is_submit === 1">
            <p>
              <el-button type="primary" size="mini" @click="reviewDialog = true" :disabled="nodeData?.paper?.is_update === 0">提交修改稿文件</el-button>
              <el-button v-if="nodeData?.paper.file" size="mini" type="text" @click="downloadFile(nodeData?.paper?.file[0]?.url, nodeData?.paper?.file[0]?.name)">
                {{ nodeData?.paper?.file[0]?.name }}
              </el-button>
            </p>
            <p>
              状态：{{ nodeData?.paper?.is_submit === 1 ? '已提交' : '未提交' }}
              <template v-if="nodeData?.paper?.is_submit === 1 && nodeData?.paper?.submit_time">
                <span style="color: #666">（提交时间：{{ timeFormat(nodeData?.paper?.submit_time * 1000) }}）</span>
              </template>
            </p>
            <p>修改稿管理员审核结果：{{ tutorState2[nodeData?.paper?.extra_state?.tutor?.state] }}</p>
            <p v-if="nodeData?.paper?.extra_state?.tutor?.remark" class="admin-remark">
              <span>反馈意见：</span>
              <span>
                {{ nodeData?.paper?.extra_state?.tutor?.remark }}
              </span>
            </p>
          </template>
          <ul v-if="nodeData?.paper?.extra_content?.review?.length > 0" class="review-list">
            <template v-for="(item, index) in nodeData?.paper?.extra_content?.review">
              <li v-if="nodeData?.batch?.content?.review_count ? index < nodeData.batch.content.review_count : true" :key="index" class="review-item">
                <p class="review-i-title">评阅{{ index + 1 }}</p>
                <div class="review-p">
                  <p class="review-title">评阅结果：</p>
                  <p class="review-desc">{{ nodeData.reviewSateTextData[item.result] }}</p>
                </div>
                <div class="review-p">
                  <p class="review-title">总体评价：</p>
                  <el-input v-model="item.evaluate" type="textarea" disabled style="max-width: 700px; color: #333" :autosize="{ minRows: 6 }"></el-input>
                  <!-- <p class="review-desc">{{ item.evaluate }}</p> -->
                </div>
                <div v-if="item.opinion" class="review-p">
                  <p class="review-title">修改意见：</p>
                  <el-input v-model="item.opinion" type="textarea" disabled style="max-width: 700px; color: #333" :autosize="{ minRows: 6 }"></el-input>
                  <!-- <p class="review-desc">{{ item.opinion }}</p> -->
                </div>
              </li>
            </template>
          </ul>
          <el-dialog :visible.sync="reviewDialog" title="提交修改稿" :close-on-click-modal="false" @close="closeReviewDialog">
            <process-form
              :child-node="nodeName"
              :is-submit="is_submit"
              :values="nodeData.paper"
              :batch-info="nodeData.batch"
              :process-node="routeInfo.name"
              @updateFn="getNodeInfo"
            ></process-form>
          </el-dialog>
        </template>
        <process-form
          v-else
          :child-node="nodeName"
          :is-submit="is_submit"
          :values="nodeData.paper"
          :batch-info="nodeData?.batch"
          :process-node="routeInfo.name"
          @updateFn="getNodeInfo"
        ></process-form>
      </template>
    </template>
    <empty-component v-else :text="stateText"></empty-component>
  </div>
</template>

<script setup>
import EmptyComponent from '../components/EmptyComponent.vue'
import ProcessForm from '../components/ProcessForm.vue'
import tutorForm from '../components/tutorForm.vue'
import API from '@/api'
import { onMounted, ref, computed } from 'vue'
import Router from '@/router'
import { downloadFile, timeFormat } from '@/utils'

const props = defineProps({
  // 子节点的属性名
  childNode: {
    type: String,
    default: ''
  }
})

const nodeName = computed(() => {
  return props.childNode
})

/**
 * 状态：
 * state ===> 状态 0-未开启 1-正常 2-提交未开始 3-已截止 4-上一个节点未完成
 * is_submit ===> 是否可以提交 0否 1是
 */

const state = ref(0)
const is_submit = ref(0)

const tutorState = ref({
  0: '未审核',
  1: '通过',
  2: '不通过',
  3: '退回修改'
})

const tutorState2 = {
  0: '未审核',
  1: '通过',
  2: '不通过',
  3: '退回修改'
}

const stateText = ref('')

// 路由信息
const routeInfo = Router.currentRoute

if (routeInfo.name === 'review_draft') {
  tutorState.value[1] = '同意答辩'
  tutorState.value[2] = '修改后答辩'
  tutorState.value[3] = '修改后答辩'
}

const loading = ref(false)

// 是否有内容
const contentState = ref(0)

// 选导信息
const tutorData = ref('')
// 获取选导数据
function getTutorData() {
  loading.value = true
  API.MBAThesisTutorData()
    .then(res => {
      if (+res.code === 200) {
        tutorData.value = res.data
        state.value = res.data.state
        stateText.value = res.data.stateText
        is_submit.value = res.is_update
        contentState.value = res.data.content_state
      }
      loading.value = false
    })
    .catch(() => {
      loading.value = false
    })
}

const nodeData = ref('')
// 获取其他节点数据
function getNodeInfo() {
  loading.value = true
  API.MBAThesisProcessInfo({ node: routeInfo.name, children: nodeName.value })
    .then(res => {
      if (+res.code === 200) {
        closeReviewDialog()
        if (!res.data.paper.file) {
          res.data.paper.file = []
        }
        // php返回数据不统一，处理成同意的数据格式，默认要有文件字段。
        // confirmation_file：导师确认单
        if (!res.data.paper.extra_content || res.data.paper.extra_content.length === 0) {
          res.data.paper.extra_content = {
            confirmation_file: []
          }
        }
        if (!res.data.paper.extra_content.confirmation_file) {
          res.data.paper.extra_content.confirmation_file = []
        }

        // 终稿和预答辩的自查重文件
        if (routeInfo.name === 'end_draft') {
          res.data.paper.extra_content.duplication_file ? '' : (res.data.paper.extra_content.duplication_file = [])
        }
        // 评阅稿重新提交文件
        if (routeInfo.name === 'review_draft' && res.data.paper.admin_state === 2 && res.data.paper.is_submit === 0) {
          res.data.paper.file = []
          res.data.paper.extra_content.confirmation_file = []
        }

        contentState.value = res.data.content_state
        stateText.value = res.data.stateText
        nodeData.value = res.data
        state.value = res.data.state
        is_submit.value = res.data.is_update
      }
      loading.value = false
    })
    .catch(() => {
      loading.value = false
    })
}

const reviewDialog = ref(false)
function closeReviewDialog() {
  reviewDialog.value = false
}

onMounted(() => {
  if (routeInfo.name === 'selection') {
    getTutorData()
  } else {
    getNodeInfo()
  }
})
</script>

<style lang="scss" scoped>
.state {
  &-3 {
    color: #e6a23c;
  }

  &-2 {
    color: #f56c6c;
  }

  &-1 {
    color: #67c23a;
  }
}

.admin-remark {
  display: flex;
  align-items: flex-start;

  span {
    white-space: pre-line;

    &:nth-child(1) {
      white-space: nowrap;
    }

    &:nth-child(2) {
      flex: 1;
    }
  }
}

.review-list {
  padding: 0;

  .review-item {
    display: block;
    border-top: 1px solid #ebeef5;
    padding-top: 15px;

    p {
      margin: 0;
    }

    .review-i-title {
      margin-bottom: 15px;
    }

    .review-p {
      display: flex;
      margin-top: 0;
      margin-bottom: 15px;
      color: #666;
    }

    .review-title {
      white-space: nowrap;
    }

    .review-desc {
      flex: 1;
      white-space: pre-line;
    }
  }
}
:deep(.el-textarea.is-disabled .el-textarea__inner) {
  color: #333;
}
</style>
